import { HttpClient } from '@angular/common/http';
import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { HttpService, LocalStorageService, SharedDataService } from '@src/app/core/services';
import { TranslateConfigService } from '@src/app/core/services/translate-config.service';
import { TranslationChangeService } from '@src/app/core/services/translation-change.service';
import { Subscription } from 'rxjs/internal/Subscription';
@Pipe({
  name: 'translateIt',
  pure: true, // Set pure to false to ensure the pipe gets re-evaluated on changes
})
export class TranslateItPipe implements PipeTransform, OnDestroy {
  private textToAdd: string = ''; // it can be object as well so we can handle multiple things here, in case of object the "key" in langague file should be placed under "key"
  private subdomainArg: boolean = false; // it can be object as well so we can handle multiple things here, in case of object the "key" in langague file should be placed under "key"
  private count = 0;
  private subscription: Subscription | undefined;
  private placeholders: Record<string, string> = {};

  constructor(
    private httpClient: HttpClient,
    private configService: TranslateConfigService,
    private localStorageService: LocalStorageService,
    private translationChangeService: TranslationChangeService,
    private apiService: HttpService,
    private sharedService: SharedDataService
  ) { }
  async transform(
    value: string,
    args?: { subdomain?: boolean; language: string; placeholders?: any },
  ): Promise<string> {
    this.textToAdd = value;
    this.placeholders = args?.placeholders;
    this.subdomainArg = args?.subdomain || false;
    // this.subscribeToLanguageChange();
    return await this.translate();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private subscribeToLanguageChange() {
    this.subscription = this.translationChangeService.language$.subscribe(() => {
      var a = this.translate();
      console.log(a);
      return a;
    });
  }

  private async translate() {
    // 1: look for current language in localstorage
    const languageCode = this.getCurrentLanguageCode();
    // 2: look for current language path created based on configService
    let jsonPath = this.getJsonPath(languageCode);
    if (this.localStorageService.get('languageOptimization') && !this.isSubDomain()) {
      // We are looking for main domain
      return this.handleOptimization(languageCode, jsonPath, 'languageOptimization');
    } else if (this.localStorageService.get('subLanguageOptimization') && this.isSubDomain()) {
      // We are looking for sub domain
      return this.handleOptimization(languageCode, jsonPath, 'subLanguageOptimization');
    } else {
      return await this.getTranslationFromFile(jsonPath);
    }
  }

  private isSubDomain() {
    return this.subdomainArg ? this.subdomainArg : false;
  }

  private getTranslationKey() {
    // get key used in json file passed through directive
    return this.textToAdd;
  }

  private getTranslationFromSession(sessionLanguageData: any) {
    let langValue = eval('sessionLanguageData.' + this.getTranslationKey());
    let translatedtext = langValue ?? this.textToAdd; // check for value otherwise just return the key if key value doesnt exsist
    return this.appendText(translatedtext);
  }

  private async getTranslationFromFile(jsonPath: string) {
    const translationData = await this.apiService.requestEntity('get', jsonPath).toPromise();
    if (translationData.body) {
      return this.handleTranslationData(translationData.body, jsonPath);
    } else {
      return this.getTranslationKey();
    }

    // this.httpClient.get(jsonPath).subscribe({
    //   next: (translationData: any) => {
    //     this.handleTranslationData(translationData, jsonPath);
    //   },
    //   error: error => {
    //     console.error('Error fetching translation data:', error);
    //     return '';
    //   },
    // });
  }

  private handleTranslationData(translationData: any, jsonPath: string) {
    // const translatedText = translationData[this.getTranslationKey()] ?? this.textToAdd;
    const translatedText = eval('translationData.' + this.getTranslationKey()) ?? this.textToAdd;
    // console.log('return inside getTranslationFromFile: ' + translatedText);

    if (this.isSubDomain()) {
      this.localStorageService.set({
        key: 'subLanguageOptimization',
        value: { path: jsonPath, languagedata: translationData },
      });
    } else {
      this.localStorageService.set({
        key: 'languageOptimization',
        value: { path: jsonPath, languagedata: translationData },
      });
    }
    return this.appendText(translatedText);
  }

  private appendText(textToReplace: string) {
    return this.replacePlaceholders(textToReplace);
  }
  private replacePlaceholders(textToReplace: string) {

    var object = this.placeholders ?? {};

    const pattern = /\{\{([^}]+)\}\}/g;

    const finalString = textToReplace.replace(pattern, (match, placeholder) => {
      return object[placeholder] ?? match; // If no replacement found, return the original match
    });

    return finalString;
  }

  private getCurrentLanguageCode(): string {
    const storedLanguage = this.localStorageService.get('language');
    return storedLanguage ? storedLanguage.code : 'en';
  }

  private getJsonPath(languageCode: string): string {
    let jsonPath = this.configService.getPath() + languageCode + '.json';
    if (this.isSubDomain()) {
      jsonPath = this.configService.getPath() + this.sharedService.tenantName + '/' + languageCode + '.json';
    }
    return jsonPath;
  }

  private handleOptimization(languageCode: string, jsonPath: string, key: string) {
    let optimizedLangObj = this.localStorageService.get(key);
    if (optimizedLangObj && optimizedLangObj.path === jsonPath) {
      // we already have its json in session
      return this.getTranslationFromSession(optimizedLangObj.languagedata);
    } else {
      // we dont have its json in session (file we have is for another page) so call http
      return this.getTranslationFromFile(jsonPath);
    }
  }
}
